import React from "react";
import { Trans } from "react-i18next";

import { useTranslation } from "lib/i18n/use-translation";
import constant from "./Constant";
import styles from "./mobile-view.module.scss";
import apple_app_store from "./Assets/apple_app_store.svg";
import google_play from "./Assets/google_play.svg";

const MobileView: React.FC = () => {
  const { t } = useTranslation("components");
  const urlObj = new URL(window.location.href);
  const mobileUrl = `walkingonearth://${urlObj.pathname}${urlObj.search}`;

  const redirectToAppleAppStoreUrl = () => {
    window.open(constant.APPLE_APP_STORE, "_blank");
  };

  const redirectToGooglePlayStoreUrl = () => {
    window.open(constant.GOOGLE_PLAY_STORE, "_blank");
  };

  const redirectToMobileUrl = () => {
    window.open(mobileUrl, "_system");
  };

  return (
    <div className={styles["mobile-view-container"]}>
      <div className={styles["mobile-view-header"]}>
        <div
          className={styles["mobile-view-logo-container"]}
          onClick={redirectToMobileUrl}
          style={{
            cursor: "pointer",
          }}
        >
          <svg
            width="130"
            height="32"
            viewBox="0 0 130 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M124.916 1.939c1.852 1.385 3.067 3.25 3.896 5.38.804 2.063 1.157 4.212 1.188 6.42.001.11-.017.22-.033.413h-21.12c.027 1.686.199 3.298.598 4.884.603 2.393 1.578 4.598 3.335 6.382 2.41 2.447 5.364 3.264 8.707 2.793 2.562-.36 4.58-1.728 6.318-3.565.343-.364.676-.741.978-1.14.212-.28.4-.374.733-.187.372.21.146.465.067.668-.674 1.754-1.667 3.306-3.026 4.613-5.173 4.974-13.519 4.416-18.01-1.182-2.102-2.62-3.212-5.62-3.465-8.935-.305-3.993.212-7.865 2.118-11.444 2.06-3.868 5.273-6.208 9.625-6.873 2.908-.445 5.67-.04 8.091 1.773zM82.327 0v6.95c.81-.942 1.503-1.796 2.247-2.604 1.323-1.435 2.78-2.715 4.598-3.505 5.205-2.26 10.878.645 12.001 6.17.211 1.038.306 2.117.313 3.178.03 5.234.069 10.47-.009 15.702-.04 2.699 1.117 3.614 3.509 4.118.217.046.436.095.657.112.342.026.352.246.357.505.006.3-.147.374-.414.374-4.027-.005-8.053-.005-12.08-.008-.07 0-.14-.031-.204-.046-.156-.73-.147-.735.5-.864.436-.087.873-.174 1.298-.299 1.849-.543 2.58-1.518 2.581-3.433.003-5.215.023-10.43-.018-15.646a11.89 11.89 0 0 0-.42-3.104c-.609-2.158-2.102-3.463-4.324-3.895-3.319-.646-6.096.45-8.497 2.679a32.227 32.227 0 0 0-1.829 1.854 1.1 1.1 0 0 0-.258.683c-.013 5.916-.016 11.832-.007 17.748.003 1.526.803 2.546 2.362 3.036.563.177 1.146.305 1.73.4.352.058.392.236.397.529.006.362-.213.365-.472.365l-5.929-.002h-6.061c-.193-.005-.349-.049-.355-.351-.006-.335.095-.463.444-.55.857-.212 1.726-.43 2.531-.78.89-.388 1.366-1.161 1.473-2.131.03-.274.04-.552.04-.828.002-6.34.003-12.68 0-19.019 0-.405-.019-.811-.058-1.214-.161-1.646-1.264-2.68-2.934-2.752-.46-.02-.923-.003-1.405-.003-.194-.609-.078-.913.517-1.095C76.697 1.636 78.766.93 80.85.277c.443-.14.919-.175 1.477-.277zm31.08 3.17c-1.743 1.137-2.829 2.753-3.531 4.66-.54 1.464-.88 2.975-.944 4.58h16.702c-.166-2.316-.521-4.536-1.527-6.604-.466-.96-1.08-1.82-1.934-2.482-2.277-1.768-6.218-1.815-8.766-.154zM47.99 1.327c.06.451-.184.578-.556.642-.25.044-.495.133-.741.203-1.246.357-2.01 1.178-2.458 2.396-1.144 3.112-2.332 6.208-3.509 9.308-1.753 4.617-3.513 9.23-5.268 13.846A431.9 431.9 0 0 0 34.04 31.5c-.099.268-.162.498-.54.5-.37.003-.453-.214-.559-.482-2.932-7.44-5.867-14.88-8.803-22.32l-.013-.025-.047-.072a3.13 3.13 0 0 1-.039-.06c-.078.165-.15.294-.202.43-1.817 4.79-3.632 9.58-5.445 14.37-.973 2.569-1.944 5.138-2.911 7.707-.096.256-.186.45-.526.45-.335.002-.487-.13-.603-.428-1.236-3.176-2.479-6.35-3.728-9.52-1.121-2.845-2.256-5.685-3.38-8.529C6.06 10.522 4.833 7.54 3.722 4.513 3.17 3.01 2.054 2.407.664 2.047c-.202-.052-.465-.114-.567-.263-.247-.362.005-.765.446-.766 3.799-.003 7.598-.002 11.397 0 .124 0 .248.026.376.04.159.507.086.8-.502.907-.737.133-1.477.311-2.176.575-1.594.603-1.92 1.423-1.31 3.03 1.008 2.654 2.003 5.312 3.006 7.966 1.447 3.825 2.896 7.65 4.345 11.473.07.186.151.368.288.696.322-.869.602-1.615.876-2.362 2.025-5.52 4.051-11.038 6.061-16.563.083-.228.059-.532-.01-.773-.121-.424-.358-.814-.472-1.24-.438-1.644-1.655-2.34-3.162-2.72-.211-.054-.497-.153-.578-.316-.217-.436.006-.71.516-.71 3.745-.002 7.489-.002 11.233.002.235 0 .529-.095.561.327.029.38-.145.5-.48.587-.92.238-1.853.454-2.736.794-.967.372-1.33 1.04-1.035 2.027.43 1.445.974 2.857 1.505 4.27 2.03 5.4 4.074 10.793 6.115 16.189.048.128.115.25.223.48.526-1.427 1.014-2.75 1.499-4.073a34733.762 34733.762 0 0 0 5.89-16.09c.038-.103.07-.21.097-.317.406-1.587.012-2.318-1.553-2.783-.683-.203-1.388-.335-2.088-.48-.68-.142-.708-.173-.518-.934h.525c2.973 0 5.946-.004 8.92.006.234.001.574-.159.635.301zm23.53 6.592c1.047 2.417 1.486 4.957 1.479 8.35-.048 3.304-.967 7.107-3.444 10.403-2.239 2.979-5.188 4.828-8.882 5.243-4.904.55-9.62-1.558-12.27-6.02-2.22-3.735-2.728-7.78-2.227-12.017.32-2.704 1.13-5.25 2.6-7.552C50.844 3.088 53.673.876 57.47.21c5.796-1.02 11.456 1.72 14.051 7.71zM55.438 2.996c-2.445 1.336-3.764 3.589-4.556 6.178-1.062 3.471-.986 6.992-.247 10.51.53 2.525 1.388 4.93 3.002 6.977 2.083 2.643 4.788 3.752 8.091 3.05 2.356-.5 4-2.037 5.192-4.085 1.516-2.602 2.011-5.466 2.043-8.439.013-2.132-.317-4.216-.88-6.261-.596-2.165-1.486-4.187-2.934-5.927-2.448-2.94-6.428-3.795-9.711-2.003z"
              fill="#ffffff"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <h6 style={{ fontFamily: "Bitter", textTransform: "initial" }}>
          <a href={mobileUrl} target="_system" rel="noreferrer">
            <Trans
              i18nKey="components:mobileView.openInApp"
              components={{
                underline: <span style={{ textDecoration: "underline" }} />,
              }}
            />
          </a>
        </h6>
      </div>
      <div className={styles["mobile-view-body"]}>
        <p>{t("components:mobileView.noAppYet")}</p>
      </div>
      <div className={styles["mobile-view-footer"]}>
        <img
          src={apple_app_store}
          alt="Apple App Store"
          className={styles["app-store-icons"]}
          onClick={redirectToAppleAppStoreUrl}
        />
        <img
          src={google_play}
          alt="Google Play Store"
          className={styles["app-store-icons"]}
          onClick={redirectToGooglePlayStoreUrl}
        />
      </div>
    </div>
  );
};

export default MobileView;
